import React, { useState, useEffect } from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { checklistAPI } from '../../services/api';

const WidgetAlertes = ({ dossierId, refreshTrigger }) => {
  const [alertes, setAlertes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (dossierId) {
      loadAlertes();
    }
  }, [dossierId, refreshTrigger]);

  const loadAlertes = async () => {
    try {
      const res = await checklistAPI.getAlertes(dossierId);
      setAlertes(res.data);
    } catch (error) {
      console.error('Erreur chargement alertes:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-gray-400">
        <Loader2 className="w-4 h-4 animate-spin" />
      </div>
    );
  }

  // Aucune alerte
  if (alertes.length === 0) {
    return (
      <div className="inline-flex items-center gap-1 px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
        ✅ Dossier complet
      </div>
    );
  }

  const errorCount = alertes.filter(a => a.niveau === 'error').length;
  const warningCount = alertes.filter(a => a.niveau === 'warning').length;

  return (
    <div className="relative">
      {/* Badge notification */}
      <button
        onClick={() => setShowDetails(!showDetails)}
        className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium transition ${
          errorCount > 0 
            ? 'bg-red-100 text-red-700 hover:bg-red-200' 
            : 'bg-orange-100 text-orange-700 hover:bg-orange-200'
        }`}
      >
        <AlertTriangle className="w-4 h-4" />
        <span>
          {warningCount > 0 && `${warningCount} manquant${warningCount > 1 ? 's' : ''}`}
          {errorCount > 0 && warningCount > 0 && ' • '}
          {errorCount > 0 && `${errorCount} expiré${errorCount > 1 ? 's' : ''}`}
        </span>
      </button>

      {/* Dropdown avec détails */}
      {showDetails && (
        <div className="absolute top-full left-0 mt-2 w-72 bg-white rounded-lg shadow-xl border border-gray-200 z-50 p-3">
          <div className="text-xs font-semibold text-gray-500 uppercase mb-2">Alertes du dossier</div>
          <div className="space-y-1 max-h-48 overflow-y-auto">
            {alertes.slice(0, 10).map((alerte, index) => (
              <div 
                key={index}
                className={`text-sm p-2 rounded ${
                  alerte.niveau === 'error' 
                    ? 'bg-red-50 text-red-700' 
                    : alerte.niveau === 'warning'
                    ? 'bg-orange-50 text-orange-700'
                    : 'bg-blue-50 text-blue-700'
                }`}
              >
                {alerte.message}
              </div>
            ))}
          </div>
          <button
            onClick={() => setShowDetails(false)}
            className="w-full mt-2 text-xs text-gray-500 hover:text-gray-700"
          >
            Fermer
          </button>
        </div>
      )}
    </div>
  );
};

export default WidgetAlertes;
